import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";
import { ICalendar } from "../../models/get";
import * as colorUtils from "../../utils/color"

interface IProperties
{
    /**
     * Kann die ID der DataSource enthalten.
     */
    dataSourceId?: number,

    /**
     * Kann die DataSource von dem der eigentliche Text stammt, enthalten.
     */
    dataSource?: ICalendar,

    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Farbe des Kalenders.
     */
    color?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Ein Wert der angibt, ob das Item selektiert ist.
     */
    isSelected?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (id: number, dataSource?: ICalendar, e?: MouseEvent) => void
}

export class HeaderCalendarItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        const { onClick, dataSourceId, dataSource } = this.props;
        onClick && onClick(dataSourceId, dataSource, e.nativeEvent);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var classNames: string[] = ["header_calendars_item"];
        if (this.props.isSelected)
            classNames.push("header_calendars_item--selected");

        var style: {
            borderLeftColor?: string,
            backgroundColor?: string,
            color?: string
        };

        if (this.props.color != null)
        {
            style = {};
            style.borderLeftColor = this.props.color;
            style.backgroundColor = colorUtils.lighten(this.props.color, .7);
            style.color = colorUtils.darken(this.props.color, .3);
        }

        return (
            <OptionalLink
                className={classNames.join(" ")}
                to={this.props.linkTo}
                style={style}
                onClick={this.onClick}>
                <span className="header_calendars_item_text">{this.props.text}</span>
            </OptionalLink>
        );
    }
}